// Nested reducers
import { transferQuotesReducer } from "./transfer-quotes/transfer-quotes.reducer";
import { autoArchiveReducer } from "./auto-archive/auto-archive.reducer";
import { inactiveCustomersReducer } from "./inactive-customers/inactive-customers.reducer";
import { sendReminderReducer } from "./send-reminder/send-reminder.reducer";
import { emailLogsReducer } from "./email-logs/email-logs.reducer";
import { webhooksReducer } from "./webhooks/webhooks.reducer";
import { attioQuoteMigrationReducer } from "./attio-quote-migration/attio-quote-migration.reducer";
import { attioRecordMigrationReducer } from "./attio-record-migration/attio-record-migration.reducer";

// **************************************************************************
// DEVELOPER REDUCER
// **************************************************************************

export const developerReducer = [
    ...transferQuotesReducer,
    ...autoArchiveReducer,
    ...inactiveCustomersReducer,
    ...sendReminderReducer,
    ...emailLogsReducer,
    ...webhooksReducer,
    ...attioQuoteMigrationReducer,
    ...attioRecordMigrationReducer,
];
